const ArticleScroll = (element) => {
  const prev = element.querySelector(".mainArticle__prev");
  const next = element.querySelector(".mainArticle__next");

  const checkScroll = () => {
    const rect = element.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    if (rect.top > 0 || rect.bottom <= viewportHeight + 200) {
      element.classList.add("nonav");
    } else if (rect.top < 0) {
      element.classList.remove("nonav");
    }
  };

  const main = () => {
    console.log("prev: ", prev);
    console.log("next: ", next);

    element.classList.add("nonav");

    window.addEventListener("scroll", checkScroll);
  };

  main();

  return () => {
    window.removeEventListener("scroll", checkScroll);
  };
};

export default ArticleScroll;
